import { routePaths } from 'components/Routes/data';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { PendingApproval } from './PendingApproval';
import { InitiatedByMe } from './InitiatedByMe';
import { Completed } from './Completed';

const FinalizePayroll = () => {
  return (
    <Switch>
      <Route path={routePaths.approvalWorkflows.myRequests.finalizePayroll.pendingApprovals} exact>
        <PendingApproval />
      </Route>
      <Route path={routePaths.approvalWorkflows.myRequests.finalizePayroll.initiatedByMe} exact>
        <InitiatedByMe />
      </Route>
      <Route path={routePaths.approvalWorkflows.myRequests.finalizePayroll.completed} exact>
        <Completed />
      </Route>
    </Switch>
  );
};

export { FinalizePayroll };
